import gsap from "gsap";
const burgerIcon = document.querySelector('.mobile-menu-btn');

const openMenu = () => {
    if (!burgerIcon) return;
    burgerIcon.classList.add('active');
    gsap.to('.mobile-menu-wrapper', {
        duration: 0.3,
        opacity: 1,
        visibility: 'visible',
        ease: 'power2.out'
    });
};

// Collapse any expanded submenu accordions so the menu reopens in its default,
// un-expanded state (e.g. after tapping an About Us anchor link).
const collapseSubMenus = () => {
    document.querySelectorAll('.mobile-submenu-container.active').forEach((subMenu) => {
        subMenu.classList.remove('active');
        gsap.set(subMenu, {height: 0});
    });
    document.querySelectorAll('.mobile-nav-menu__item-arrow.active').forEach((arrow) => {
        arrow.classList.remove('active');
    });
};

const closeMenu = () => {
    if (!burgerIcon || !burgerIcon.classList.contains('active')) return;
    burgerIcon.classList.remove('active');
    gsap.to('.mobile-menu-wrapper', {
        duration: 0.2,
        opacity: 0,
        visibility: 'hidden',
        ease: 'power2.out',
        onComplete: collapseSubMenus
    });
};

if(burgerIcon) {
    burgerIcon.addEventListener('click', () => {
        if(burgerIcon.classList.contains('active')) {
            closeMenu();
        } else {
            openMenu();
        }
    });
}

const mobileNavItem = document.querySelectorAll('.mobile-menu-wrapper .mobile-nav-menu__item.has-children');
if(mobileNavItem) {
    mobileNavItem.forEach((item) => {
        const arrow = item.querySelector('.mobile-nav-menu__item-arrow');

        if(!arrow) {
            return;
        }

        arrow.addEventListener('click', (e) => {
            e.stopPropagation();
            const subMenu = item.querySelector('.mobile-submenu-container');

            if(subMenu.classList.contains('active')) {
                subMenu.classList.remove('active');
                gsap.to(subMenu, {duration: 0.3, height: 0});
                arrow.classList.remove('active');
            } else {
                subMenu.classList.add('active');
                gsap.to(subMenu, {duration: 0.3, height: 'auto'});
                arrow.classList.add('active');
            }
        });
    });
}

// Close the mobile menu whenever a navigable link inside it is clicked.
// Entry links (e.g. Our Services children) close naturally via full page
// navigation, but same-page anchor links (e.g. About Us children pointing to
// custom URLs that resolve to #anchors) keep the menu deployed — so we close
// it explicitly here for every link, which is the correct mobile behaviour.
const mobileMenuLinks = document.querySelectorAll('.mobile-menu-wrapper a');
mobileMenuLinks.forEach((link) => {
    link.addEventListener('click', () => {
        closeMenu();
    });
});
